{
  "fr": {
    "published": {
      "labels": {
        "publishedCustomerPartners": "Publié pour les clients et les partenaires",
        "publishedCustomer": "Publié pour les clients",
        "publishedPartners": "Publié pour les partenaires",
        "notPublished": "Non publié"
      }
    }
  }
}
